import * as React from 'react';
import * as I18n from 'i18n-js';
import CategoryItem from './category_item';
import categoryData from './category_data';
import bind from '@reverbdotcom/commons/dist/bind';

import Tiles from '@reverbdotcom/commons/dist/components/tiles';
import OverflowingRow from '@reverbdotcom/commons/dist/components/overflowing_row';
import { trackView, CATEGORY_TYPE } from '@reverbdotcom/commons/dist/tracker';

interface IProps {
  noTitle?: boolean;
}

export default class HomepageCategories extends React.Component<IProps, null> {
  static defaultProps = {
    noTitle: false,
  };

  componentDidMount() {
    trackView({
      componentName: 'CategoriesRow',
      type: CATEGORY_TYPE,
      ids: categoryData.map(cat => cat.uuid),
    });
  }

  title() {
    if (this.props.noTitle) { return null; }

    return I18n.t('discovery.homepage.categories.heading');
  }

  @bind
  renderCategoryItem(cat, i) {
    return (
      <CategoryItem
        key={cat.uuid}
        categoryItem={cat}
        position={i}
      />
    );
  }

  render() {
    return (
      <section className="homepage-container__component-wrapper homepage-container__component-wrapper--thin">
        <OverflowingRow
          title={this.title()}
        >
          <Tiles
            loading={false}
            expectedCount={categoryData.length}
            singleRow
            largeTiles
          >
            {categoryData.map(this.renderCategoryItem)}
          </Tiles>
        </OverflowingRow>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage_categories.tsx